import axios from 'axios';

// #region ======== auth =========

// Admin Login
async function loginAsync(payload) {
  const config = {
    method: 'post',
    url: 'admin/login',
    data: payload
  };
  return await axios(config);
}

async function renewSessionAsync(payload) {
  const config = {
    method: 'post',
    url: '/admin/renew',
    data: payload
  };
  return await axios(config);
}

async function addAdminAsync(payload) {
  const config = {
    method: 'post',
    url: 'admin/user',
    data: payload
  };
  return await axios(config);
}

async function updateAdminAsync(payload) {
  const config = {
    method: 'put',
    url: 'admin/user',
    data: payload
  };
  return await axios(config);
}

async function getRoleListAsync() {
  const config = {
    method: 'get',
    url: '/admin/role-list'
  };
  return await axios(config);
}

async function resetAdminPasswordAsync(payload) {
  const config = {
    method: 'post',
    url: '/admin/reset/admin/password',
    data: payload
  };
  return await axios(config);
}

async function resetPasswordAsync(payload) {
  const config = {
    method: 'post',
    url: '/admin/reset/password',
    data: payload
  };
  return await axios(config);
}

async function getFlavoursAsync() {
  const config = {
    method: 'get',
    url: `/lookup/flavours`
  };
  return await axios(config);
}
// #endregion ======== auth =========

// #start-order ======== order =========

async function getOrderListAsync(payload) {
  const config = {
    method: 'post',
    url: '/order/list',
    data: payload
  };
  return await axios(config);
}

async function getOrderStatistcsAsync(payload) {
  const config = {
    method: 'post',
    url: '/order/statistics',
    data: payload
  };
  return await axios(config);
}

async function getOrderDetailAsync(orderId) {
  const config = {
    method: 'get',
    url: `/order/details/${orderId}`
  };
  return await axios(config);
}

async function getCustomerListAsync(payload) {
  const config = {
    method: 'post',
    url: '/order/customer',
    data: payload
  }
  return await axios(config);
}

async function cancelOrderAsync(orderId) {
  const config = {
    method: 'delete',
    url: `/order/cancel-order/${orderId}`
  };
  return await axios(config);
}

async function orderRefundAsync(orderId, payload) {
  const config = {
    method: 'post',
    url: `/order/refund/${orderId}`,
    data: payload
  };
  return await axios(config);
}

async function creditPointsAsync(payload) {
  const config = {
    method: 'post',
    url: '/payment/points',
    data: payload
  };
  return await axios(config);
}

async function getCreditPointsAsync(orderId, payload) {
  const config = {
    method: 'get',
    url: `/payment/points/${orderId}`,
    data: payload
  };
  return await axios(config);
}
async function getOrderPayRequestDetailAsync(orderId) {
  const config = {
    method: 'get',
    url: `/order/pay-request/${orderId}`
  };
  return await axios(config);
}

async function getUserPayRequestDetailByIdAsync(payRequestId) {
  const config = {
    method: 'post',
    url: '/user/pay-request',
    data: payRequestId
  };
  return await axios(config);
}

async function voidPayRequestAsync(payRequestId) {
  const config = {
    method: 'get',
    url: `/payment/void-request/${payRequestId}`,
    data: payRequestId
  };
  return await axios(config);
}

async function viewOrderAsync(orderId) {
  const config = {
    method: 'get',
    url: `/order/validJson/${orderId}`
  };
  return await axios(config);
}

async function orderDeliveryRequestAsync(siteId, deliveryId) {
  const config = {
    method: 'get',
    url: `/order/delivery-request/${siteId}/${deliveryId}`
  };
  return await axios(config);
}

async function getCustomerOrdersAsync(phone) {
  const config = {
    method: 'post',
    url: `/order/customer/orders`,
    data: { phone: phone }
  }
  return await axios(config);
}

async function blockCustomerAsync(userId, block) {
  const config = {
    method: 'post',
    url: `/order/customer/block`,
    data: { userId, block }
  }
  return await axios(config);
}
// #end-order ======== order =========

// #start-site ======== site =========

async function getSitesOptionsAsync() {
  const config = {
    method: 'get',
    url: '/sites'
  };
  return await axios(config);
}

async function getSiteListAsync() {
  const config = {
    method: 'get',
    url: '/admin/user-site'
  };
  return await axios(config);
}

async function getSitesByIdAsync(systemUserId) {
  const config = {
    method: 'get',
    url: `/admin/user-sites/${systemUserId}`
  };
  return await axios(config);
}

// #start-feedback ======== feedback =========

async function getFeedbackSummaryAsync(payload) {
  const config = {
    method: 'post',
    url: '/feedback/summary',
    data: payload
  };
  return await axios(config);
}

async function getFeedbackListAsync(payload) {
  const config = {
    method: 'post',
    url: '/feedback/list',
    data: payload
  };
  return await axios(config);
}

// #end-feedback ======== feedback =========

// Disabled PosItem
async function getDisabledPosItemListAsync(itemType) {
  const config = {
    method: 'get',
    url: '/admin/disabled/items',
    params: { itemType: itemType }
  };
  return await axios(config);
}

// delete Disabled combo
async function enableComboAsync(payload) {
  const config = {
    method: 'put',
    url: '/admin/enable/combo',
    data: payload
  };
  return await axios(config);
}

// delete Disabled PosItem
async function enablePosItemAsync(payload) {
  const config = {
    method: 'delete',
    url: '/admin/enable/item',
    data: payload
  };
  return await axios(config);
}

// add Disable PosItem
async function disablePosItemAsync(payload) {
  const config = {
    method: 'post',
    url: '/admin/disable/item',
    data: payload
  };
  return await axios(config);
}

async function disableComboAsync(payload) {
  const config = {
    method: 'put',
    url: '/admin/disable/combo',
    data: payload
  };
  return await axios(config);
}

async function getPosItemOptionListAsync() {
  const config = {
    method: 'get',
    url: '/admin/positem/options'
  };
  return await axios(config);
}

async function getComboOptionListAsync() {
  const config = {
    method: 'get',
    url: '/admin/combo/options'
  };
  return await axios(config);
}

async function getModifierOptionListAsync() {
  const config = {
    method: 'get',
    url: '/menu/modifier-options'
  };
  return await axios(config);
}

//Dashboard

async function getReportListAsync() {
  const config = {
    method: 'get',
    url: '/lookup/reports'
  };
  return await axios(config);
}

async function getAnalyticsChartsAsync() {
  const config = {
    method: 'get',
    url: '/lookup/charts'
  };
  return await axios(config);
}

async function getDailyReportWidgetsAsync() {
  const config = {
    method: 'post',
    url: '/sales/widgets'
  };
  return await axios(config);
}

async function getChartDataAsync(payload) {
  const config = {
    method: 'post',
    data: payload,
    url: `/sales/charts`
  };
  return await axios(config);
}

async function getAdhocReport(payload) {
  const config = {
    method: 'post',
    data: payload,
    url: `/sales/reports`
  };
  return await axios(config);
}

async function getUomListAsync() {
  const config = {
    method: 'get',
    url: '/lookup/uom-list'
  };
  return await axios(config);
}


async function getUomItemAsync() {
  const config = {
    method: 'get',
    url: '/lookup/uomItem'
  };
  return await axios(config);
}

//Start of POS
async function getEmpListAsync() {
  const config = {
    method: 'get',
    url: '/pos/emp-list'
  };
  return await axios(config);
}

async function deleteEmpAsync(empId) {
  const config = {
    method: 'delete',
    url: `/pos/emp/${empId}`
  };
  return await axios(config);
}

async function addEmpAsync(payload) {
  const config = {
    method: 'post',
    url: '/pos/emp',
    data: payload
  };
  return await axios(config);
}

async function updateEmpAsync(payload) {
  const config = {
    method: 'put',
    url: '/pos/emp',
    data: payload
  };
  return await axios(config);
}

async function getReceiptDetailsAsync(apiUrl, orderId) {
  let url = '';
  if (apiUrl) {
    url = `${apiUrl}/lookup/receipt/${orderId}`;
  } else {
    url = `lookup/receipt/${orderId}`;
  }
  const config = { method: 'get', url: url };
  return await axios(config);
}

// PO Order
async function getPOListAsync(showOnlyOpenPO) {
  const config = {
    method: "get",
    url: `/po/po-list/${showOnlyOpenPO}`,
  };
  return await axios(config);
}


async function getPOAsync(orderId) {
  const config = {
    method: "get",
    url: `/po/po-items/${orderId}`,
  };
  return await axios(config);
}


async function savePOAsync(payload) {
  const config = {
    method: "post",
    url: "/po/savePO",
    data: payload,
  };
  return await axios(config);
}

async function deletePOAsync(orderId) {
  const config = {
    method: "delete",
    url: `/po/order/${orderId}`,
  };
  return await axios(config);
}

async function getSuppliersAsync() {
  const config = {
    method: "get",
    url: `/po/supplier-list`,
  };
  return await axios(config);
}

async function getIngredientListBySupplierIdAsync(siteId, supplierId) {
  const config = {
    method: 'get',
    url: `/po/ingredient-list-by-supplierId/${siteId}/${supplierId}`
  };
  return await axios(config);
}

async function getIngredientUsageAsync(siteId) {
  const config = {
    method: 'get',
    url: `/po/ingredient-usage/${siteId}`
  };
  return await axios(config);
}

async function getSalesDataAsync(siteId) {
  const config = {
    method: 'get',
    url: `/po/site-sales-data/${siteId}`
  };
  return await axios(config);
}
async function getIngredientListAsync(itemType) {
  const config = {
    method: 'get',
    url: `/po/ingredient-list/${itemType}`
  };
  return await axios(config);
}

async function getFilterListAsync() {
  const config = {
    method: 'get',
    url: '/po/filter-list',
  };
  return await axios(config);
}


async function getPhysicalStockListAsync(siteId, stockStartDate, stockEndDate) {
  const config = {
    method: 'get',
    url: `/po/physical-stock-list/${siteId}/${stockStartDate}/${stockEndDate}`,
  };
  return await axios(config);
}


async function getUomListByIngredientId(ingredientId) {
  const config = {
    method: 'get',
    url: `/po/uom-list-by-ingredientId/${ingredientId}`,
  };
  return await axios(config);
}


async function getUomConvertListByIngredientId(ingredientId) {
  const config = {
    method: 'get',
    url: `/po/uom-convert-list-by-ingredientId/${ingredientId}`,
  };
  return await axios(config);
}


async function savePhysicalStockAsync(payload) {
  const config = {
    method: "post",
    url: "/po/save-physical-stock",
    data: payload,
  };
  return await axios(config);
}

async function getStockReportAsync(payload) {
  const config = {
    method: 'post',
    url: '/po/stockReport',
    data: payload
  };
  return await axios(config);
}

async function getCookedWasteListAsync(siteId, stockStartDate, stockEndDate) {
  const config = {
    method: 'get',
    url: `/po/cooked-waste-list/${siteId}/${stockStartDate}/${stockEndDate}`,
  };
  return await axios(config);
}


async function getIngredientWasteListAsync(siteId, stockStartDate, stockEndDate) {
  const config = {
    method: 'get',
    url: `/po/ingredient-waste-list/${siteId}/${stockStartDate}/${stockEndDate}`,
  };
  return await axios(config);
}

async function getPosIngredientListAsync() {
  const config = {
    method: 'get',
    url: '/po/pos-ingredient-list'
  };
  return await axios(config);
}

async function saveRawWasteDataAsync(payload) {
  const config = {
    method: "post",
    url: "/po/save-raw-waste",
    data: payload,
  };
  return await axios(config);
}

async function saveCookedWasteDataAsync(payload) {
  const config = {
    method: "post",
    url: "/po/save-cooked-waste",
    data: payload,
  };
  return await axios(config);
}


export default {
  // auth
  loginAsync,
  addAdminAsync,
  updateAdminAsync,
  getRoleListAsync,
  resetAdminPasswordAsync,
  resetPasswordAsync,
  renewSessionAsync,

  getSiteListAsync,
  getSitesOptionsAsync,
  getSitesByIdAsync,
  getFlavoursAsync,

  // Order Detail
  getOrderListAsync,
  getOrderStatistcsAsync,
  getOrderDetailAsync,
  getCustomerListAsync,
  cancelOrderAsync,
  orderRefundAsync,
  getOrderPayRequestDetailAsync,
  getUserPayRequestDetailByIdAsync,
  voidPayRequestAsync,
  orderDeliveryRequestAsync,
  creditPointsAsync,
  getCreditPointsAsync,
  viewOrderAsync,
  getCustomerOrdersAsync,
  blockCustomerAsync,

  // feedback & review
  getFeedbackSummaryAsync,
  getFeedbackListAsync,

  // Disabled PosItem
  getDisabledPosItemListAsync,
  enablePosItemAsync,
  enableComboAsync,
  disablePosItemAsync,
  disableComboAsync,
  getPosItemOptionListAsync,
  getComboOptionListAsync,
  getModifierOptionListAsync,

  // Dashboard analytics
  getAdhocReport,
  getDailyReportWidgetsAsync,
  getChartDataAsync,
  getReportListAsync,
  getAnalyticsChartsAsync,

  //POS Employee
  getEmpListAsync,
  deleteEmpAsync,
  addEmpAsync,
  updateEmpAsync,
  getReceiptDetailsAsync,

  // PO Order
  getPOListAsync,
  getPOAsync,
  savePOAsync,
  deletePOAsync,
  getSuppliersAsync,
  getIngredientListBySupplierIdAsync,
  getFilterListAsync,
  getIngredientListAsync,
  getPhysicalStockListAsync,
  getUomListByIngredientId,
  getUomConvertListByIngredientId,
  savePhysicalStockAsync,
  getStockReportAsync,
  getIngredientUsageAsync,
  getSalesDataAsync,
  getUomListAsync,
  getUomItemAsync,

  getCookedWasteListAsync,
  getIngredientWasteListAsync,
  getPosIngredientListAsync,
  saveRawWasteDataAsync,
  saveCookedWasteDataAsync,
};
